import {
  Button,
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Badge,
  UncontrolledTooltip,
  Modal,
  ModalHeader,
  ModalBody,
  Form,
  Input,
  FormFeedback,
  Label,
} from "reactstrap"
import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { withRouter, Link, useLocation } from "react-router-dom"
import { getDateString, getOrderPrefix } from "helpers/common_helper"
import { Type } from "react-bootstrap-table2-editor"
import { WindowScrollController } from "@fullcalendar/core"

const columns = (
  toggle,
  handleValidDate,
  handleOrderClick,
  onClickDelete,
  toLowerCase1,
  toggleViewModal,
  toggleRtCanvas,
  toggleOrderFormModel,
  toggleInvoiceHistoryModel,
  designers,
  sales,
  path
) => {
  const columns = [
    {
      dataField: "Sno",
      text: "S#",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      formatter: (cell, row, rowIndex, formatExtraData) => {
        return rowIndex + 1
      },
    },
    {
      dataField: "workStatus",
      text: "Status",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
    },
    {
      dataField: "customerNick",
      text: "Customer Name",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
    },
    {
      dataField: "invHistory",
      text: "Inv History",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <button className="btn btn-sm btn-primary"
        onClick={() => toggleInvoiceHistoryModel(row)}>Inv History</button>
      ),
    },
    
    {
      dataField: "genHistory",
      text: "Gen Invoice",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, row) => (
        <button
          className="btn btn-sm btn-primary"
          onClick={() => toggleRtCanvas(row)}
        >
          Gen Invoice
        </button>
      ),
    },
    {
      dataField: "contactPerson",
      text: "Contact Person",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
    },
    {
      dataField: "userName",
      text: "User Name",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
    },
    {
      dataField: "password",
      text: "Password",
      sort: true,
      // Product Name column can't be edit anymore
      editable: true,
    },
    {
      dataField: "company",
      text: "Company",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
    },
    {
      dataField: "phone",
      text: "Phone",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
    },
    {
      dataField: "email",
      text: "Email",
      sort: true,
      // Product Name column can't be edit anymore
      editable: true,
    },
    {
      dataField: "reffrence",
      text: "Reference",
      sort: true,
      // Product Name column can't be edit anymore
      editable: false,
    },
    {
      dataField: "colorStatus",
      text: "Color Status",
      sort: false,
      editor: {
        type: Type.SELECT,
        options: [
          {
            value: "Nothing",
            label: "Nothing",
          },
          {
            value: "Red",
            label: "Red",
          },
          {
            value: "Green",
            label: "Green",
          },
        ],
      },
      formatter: (cellContent, row) => {
        return (
        <button
          className={
            row?.colorStatus == "Green"
              ? "btn btn-sm btn-success"
              : "btn btn-sm btn-danger"
          }
        >
          {row?.colorStatus || "Nothing"}
        </button>
      )},
    },
    {
      dataField: "comments",
      text: "Comments",
      sort: true,
      editable: true,
    },
    {
      dataField: "assToSalesMan",
      text: "Ass To Sales",
      sort: true,
      editor: {
        type: Type.SELECT,
        getOptions: setOptions => {
          let rec = []
          sales.docs.map(t => {
            rec.push({
              value: t.userName,
              label: t.userName,
            })
          })
          return rec
        },
      },
      formatter: (cellContent, row) => {
        return (
        <span
          className={
             !row.hasOwnProperty("assToSalesMan")
              ? "btn btn-sm btn-danger"
              : "btn btn-sm btn-primary"
          }
        >
          {row.assToSalesMan}
        </span>
      )},
    },
    {
      dataField: "records",
      isDummyField: true,
      text: "Records",
      // Product Name column can't be edit anymore
      editable: false,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, order) => (
        <>
          <ul className="list-inline mb-0">
            <li className="list-inline-item me-3" id="comments">
              <Link
                to="#"
                className="text-secondary"
                onClick={() => toggleOrderFormModel("Quote", order)}
              >
                {/* {order.userName} */}

                <i
                  className="fab fa-digital-ocean font-size-18"
                  id="quote"
                />
                {/* <UncontrolledTooltip delay={{ show: 0, hide: 0 }} transition={{ timeout: 0 }} placement="top" target="quote"   >
                  Quote
                </UncontrolledTooltip> */}
              </Link>
            </li>
            <li className="list-inline-item me-3">
              <Link
                to="#"
                className="text-secondary"
                onClick={() => toggleOrderFormModel("Order", order)}
              >
                <i className="fab fa-opera font-size-18" id="order" />
                {/* <UncontrolledTooltip delay={{ show: 0, hide: 0 }} transition={{ timeout: 0 }} placement="top" target="order">
                  Order
                </UncontrolledTooltip> */}
              </Link>
            </li>
            <li className="list-inline-item me-3" id="dueDate">
              <Link
                to="#"
                className="text-secondary"
                onClick={() => toggleOrderFormModel("Vector", order)}
              >
                <i className="fab fa-vuejs font-size-18" id="vector" />
                {/* <UncontrolledTooltip delay={{ show: 0, hide: 0 }} transition={{ timeout: 0 }} placement="top" target="vector">
                  Vector
                </UncontrolledTooltip> */}
              </Link>
            </li>
          </ul>
        </>
      ),
    },
    {
      dataField: "action",
      isDummyField: true,
      text: "Del",
      // Product Name column can't be edit anymore
      editable: false,
      // eslint-disable-next-line react/display-name
      formatter: (cellContent, customer) => (
        <>
          <div className="d-flex gap-3">
            <Link
              to="#"
              className="text-danger"
              onClick={() => onClickDelete(customer)}
            >
              <i className="mdi mdi-delete font-size-18" id="deletetooltip" />
              {/* <UncontrolledTooltip delay={{ show: 0, hide: 0 }} transition={{ timeout: 150 }} placement="top" target="deletetooltip">
                Delete 
              </UncontrolledTooltip> */}
            </Link>
          </div>
        </>
      ),
    },
  ]

  let filterdColumns = []

  switch (window.location.pathname) {
    case "/customers":
      filterdColumns = columns.filter(
        r =>
          r.dataField === "Sno" ||
          r.dataField === "workStatus" ||
          r.dataField === "customerNick" ||
          r.dataField === "invHistory" ||
          r.dataField === "genHistory" ||
          r.dataField === "contactPerson" ||
          r.dataField === "company" ||
          r.dataField === "phone" ||
          r.dataField === "email" ||
          r.dataField === "reffrence" ||
          r.dataField === "colorStatus" ||
          r.dataField === "comments" ||
          r.dataField === "records" ||
          r.dataField === "userName" ||
          r.dataField === "action" ||
          r.dataField === "assToSalesMan"
      )
      break
    case "/all-customers":
      filterdColumns = columns.filter(
        r =>
          r.dataField === "Sno" ||
          r.dataField === "registerdDate" ||
          // r.dataField === "workStatus" ||
          r.dataField === "userName" ||
          r.dataField === "password" ||

          r.dataField === "customerNick" ||
          r.dataField === "contactPerson" ||
          r.dataField === "company" ||
          r.dataField === "phone" ||
          r.dataField === "email" ||
          r.dataField === "assToSalesMan"
      )
      break
  }

  return filterdColumns
}

columns.propTypes = {
  toggle: PropTypes.func,
  designers: PropTypes.object,
  sales: PropTypes.object,
  handleValidDate: PropTypes.func,
  handleOrderClick: PropTypes.func,
  onClickDelete: PropTypes.func,
  locationPath: PropTypes.string,
  toggleRtCanvas: PropTypes.func,
  toggleOrderFormModel: PropTypes.func,
  toggleInvoiceHistoryModel: PropTypes.func
}

export default columns
